import { TemplateConfig } from '../types';

export const destinyWheelConfig: TemplateConfig = {
  id: 'destiny-wheel',
  name: '命运之轮牌阵',
  description: '分析感情走向的来龙去脉和发展趋势',
  cardCount: 6,
  
  fieldDefaults: {
    title: '命运之轮牌阵',
    customerQuestion: '分析我和对方之间的感情走向。',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 2 列第 2 张牌'
    ],
    cardInfos: [
      '我和对方是命中注定吗',
      '我和对方的缘分程度',
      '这段感情能被认可吗',
      '遇到障碍是否能不被拆散',
      '对方改变了我什么',
      '我和对方的感情因果'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '🎡'
  }
};